

import state from './moduleArtisansState.js'
import mutations from './moduleArtisansMutations.js'
import actions from './moduleArtisansActions.js'
import getters from './moduleArtisansGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

